<template>
  <div class="container-fluid">
    <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors, isSubmitting }" :disabled="isSaving">
      <ul class="nav nav-tabs mt-2 mb-2" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <span class="nav-link disabled text-primary fw-bold">{{ supplierNameTitle }}</span>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="head-tab" data-bs-toggle="tab" data-bs-target="#head-tab-pane" type="button" role="tab" aria-controls="head-tab-pane" aria-selected="true">{{ $t('field.generic.general') }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <div class="ms-3 btn-group">
            <button type="submit" class="btn btn-primary" :disabled="isSubmitting || !requiredFieldsComplete">
              <div v-if="isSaving" class="spinner-border spinner-border-sm"></div>
              <font-awesome-icon v-else :icon="['fas', 'floppy-disk']" />
              {{ $t('action.save') }}
            </button>
          </div>
          <div v-if="errors.apiError" class="alert alert-danger mt-3 mb-0">{{ errors.apiError }}</div>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active container align-items-center" id="head-tab-pane" role="tabpanel" aria-labelledby="head-tab" tabindex="0">

          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="code" class="form-label required" :title="$t('field.supplier.supplierCodeTitle')">{{ $t('field.supplier.supplierCode') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="code" name="code" type="text" class="form-control" :class="{ 'is-invalid': errors.code }" maxlength="20" v-model="supplierCode" />
              <div class="invalid-feedback" v-if="!!errors.code">{{ errors.code }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="name" class="form-labe required">{{ $t('field.generic.name') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="name" name="name" type="text" class="form-control" :class="{ 'is-invalid': errors.name }" maxlength="100" v-model="supplierName" />
              <div class="invalid-feedback" v-if="!!errors.name">{{ errors.name }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="email" class="form-label required">{{ $t('field.generic.email') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="email" name="email" type="text" class="form-control" :class="{ 'is-invalid': errors.email }" maxlength="256" v-model="supplierEmail" />
              <div class="invalid-feedback" v-if="!!errors.email">{{ errors.email }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="cultureName" class="form-label" :title="$t('field.supplier.cultureNameTitle')">{{ $t('field.supplier.cultureName') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="cultureName" name="cultureName" as="select" class="form-select" style="max-width: 16rem;" v-model="supplierCultureName">
                <option v-for="culture in selectableCultures" :key="culture.code" :value="culture.code">{{ $t(culture.nameKey) }}</option>
              </Field>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="customerCode" class="form-label required" :title="$t('field.supplier.customerCodeTitle')">{{ $t('field.supplier.customerCode') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="customerCode" name="customerCode" type="text" class="form-control" :class="{ 'is-invalid': errors.customerCode }" maxlength="20" v-model="supplierCustomerCode" />
              <div class="invalid-feedback" v-if="!!errors.customerCode">{{ errors.customerCode }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="companyName" class="form-label">{{ $t('field.generic.company') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="companyName" name="companyName" type="text" class="form-control" :class="{ 'is-invalid': errors.companyName }" maxlength="100" v-model="supplierCompanyName" />
              <div class="invalid-feedback" v-if="!!errors.companyName">{{ errors.companyName }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="address" class="form-label">{{ $t('field.generic.address') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="address" name="address" type="text" as="textarea" rows="4" class="form-control" :class="{ 'is-invalid': errors.address }" maxlength="400" v-model="supplierAddress" />
              <div class="invalid-feedback" v-if="!!errors.address">{{ errors.address }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="contactName" class="form-label">{{ $t('field.generic.contactName') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="contactName" name="contactName" type="text" class="form-control" :class="{ 'is-invalid': errors.contactName }" maxlength="100" v-model="supplierContactName" />
              <div class="invalid-feedback" v-if="!!errors.contactName">{{ errors.contactName }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="phone" class="form-label">{{ $t('field.generic.phone') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <Field id="phone" name="phone" type="text" class="form-control" :class="{ 'is-invalid': errors.phone }" maxlength="20" v-model="supplierPhone" />
              <div class="invalid-feedback" v-if="!!errors.phone">{{ errors.phone }}</div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="autoOrderEnabled" class="form-label" :title="$t('field.supplier.autoOrderEnabledTitle')">{{ $t('field.supplier.autoOrderEnabled') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <div class="form-check">
                <Field id="autoOrderEnabled" name="autoOrderEnabled" type="checkbox" class="form-check-input" :value="true" :unchecked-value="false" v-model="supplierAutoOrderEnabled" />
              </div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2">
              <label for="autoConfirmOrder" class="form-label" :title="$t('field.supplier.autoConfirmOrderTitle')">{{ $t('field.supplier.autoConfirmOrder') }}</label>
            </dt>
            <dd class="col-sm-8 col-lg-10">
              <div class="form-check">
                <Field id="autoConfirmOrder" name="autoConfirmOrder" type="checkbox" class="form-check-input" :value="true" :unchecked-value="false" v-model="supplierAutoConfirmOrder" />
              </div>
            </dd>
          </dl>
          <dl class="row mb-0">
            <dt class="col-sm-4 col-lg-2"></dt>
            <dd class="col-sm-8 col-lg-10">
              <div v-if="!requiredFieldsComplete" class="alert alert-info mt-3 mb-0">
                <font-awesome-icon :icon="['fas', 'info-circle']" />
                <span class="ms-2">{{ $t('instruction.provideRequiredFields') }}</span>
              </div>
              <button v-else type="submit" class="btn btn-primary" :disabled="isSubmitting || !requiredFieldsComplete">
                <div v-if="isSaving" class="spinner-border spinner-border-sm"></div>
                <font-awesome-icon v-else :icon="['fas', 'floppy-disk']" />
                {{ $t('action.save') }}
              </button>
            </dd>
          </dl>
          <div v-if="errors.apiError" class="alert alert-danger mt-3 mb-0">{{ errors.apiError }}</div>

        </div>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Id, toast, type ToastOptions } from 'vue3-toastify';
import * as Yup from 'yup';
import { Form, Field, GenericObject } from 'vee-validate';
import { useSessionStore, useSuppliersStore, useSupplierItemsStore } from '@/stores';
import { router } from '@/services';
import { useI18n } from 'vue-i18n';
import UpsertSupplierRequest from '@/models/requests/UpsertSupplierRequest';
import SupplierWithItems from '@/models/frontend/SupplierWithItems';

const supplierCode = ref('');
const supplierName = ref('');
const supplierEmail = ref('');
const supplierCustomerCode = ref('');
const supplierCompanyName = ref(undefined as string | undefined);
const supplierAddress = ref(undefined as string | undefined);
const supplierContactName = ref(undefined as string | undefined);
const supplierPhone = ref(undefined as string | undefined);
const defaultMailCulture = 'de';
const supplierCultureName = ref(defaultMailCulture as string);
const supplierAutoConfirmOrder = ref(true);
const supplierAutoOrderEnabled = ref(true);

const selectableCultures = computed(() => {
  const cultures = [
    { code: 'en', nameKey: 'language.en' },
    { code: 'de', nameKey: 'language.de' },
    { code: 'fr', nameKey: 'language.fr' }
  ];
  return cultures.sort((a, b) => i18n.t(a.nameKey).localeCompare(i18n.t(b.nameKey), i18n.locale.value));
});

const sessionStore = useSessionStore();
const suppliersStore = useSuppliersStore();
const supplierItemsStore = useSupplierItemsStore();

const { selectedTenantId } = storeToRefs(sessionStore);

const i18n = useI18n();

const isSaving = ref(false);
const toastId = ref('' as Id);

const schema = Yup.object().shape({
  code: Yup.string().required(i18n.t('validation.codeRequired')).max(20, i18n.t('validation.maxLength', { max: 20 })),
  name: Yup.string().required(i18n.t('validation.nameRequired')).max(100, i18n.t('validation.maxLength', { max: 100 })),
  email: Yup.string().email(i18n.t('validation.emailRequired')).required(i18n.t('validation.emailRequired')).max(256, i18n.t('validation.maxLength', { max: 256 })),
  customerCode: Yup.string().required(i18n.t('validation.required')).max(20, i18n.t('validation.maxLength', { max: 20 })),
  companyName: Yup.string().notRequired().max(100, i18n.t('validation.maxLength', { max: 100 })),
  address: Yup.string().notRequired().max(400, i18n.t('validation.maxLength', { max: 400 })),
  contactName: Yup.string().notRequired().max(100, i18n.t('validation.maxLength', { max: 100 })),
  phone: Yup.string().notRequired().max(20, i18n.t('validation.maxLength', { max: 20 })),
  cultureName: Yup.string().notRequired().max(10, i18n.t('validation.maxLength', { max: 10 })),
  autoConfirmOrder: Yup.boolean().notRequired(),
  autoOrderEnabled: Yup.boolean().notRequired(),
});

const requiredFieldsComplete = computed(() => supplierCode.value !== '' && supplierName.value !== '' && supplierEmail.value !== '' && supplierCustomerCode.value !== '');
const supplierNameTitle = computed(() => supplierName.value === undefined || supplierName.value === '' ? i18n.t('placeholder.newSupplier') : supplierName.value);

const onApiFulfilled = async (supplier: SupplierWithItems) => {
    isSaving.value = false;
    toast.update(toastId.value, {
      render: i18n.t('statement.supplierSaved', { supplierCode: supplier.code }),
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      autoClose: 10000,
      closeOnClick: true
    } as ToastOptions);
    router.push({ name: 'supplier', params: { supplierId: supplier.id } });
};

const onApiRejected = (error: Error) => {
    isSaving.value = false;
    toast.update(toastId.value, {
      render: i18n.t('error.supplierSaveError', { error: error.message }),
      closeOnClick: true,
      type: toast.TYPE.ERROR,
      isLoading: false
    } as ToastOptions);
};

const onSubmit = async (values: GenericObject, { setErrors }: GenericObject) => {
  const { code, name, email, customerCode, companyName, address, contactName, phone, cultureName, autoConfirmOrder, autoOrderEnabled } = values;

  try {
    isSaving.value = true;
    toastId.value = toast.loading(i18n.t('status.savingEllipsis'), {
      autoClose: false,
      theme: 'colored'
    } as ToastOptions);
    const newOrUpdatedSupplier = new UpsertSupplierRequest(selectedTenantId.value, code, name, email, customerCode, companyName, address, contactName, phone, cultureName, autoConfirmOrder ?? true, autoOrderEnabled ?? true, []);
    await suppliersStore.upsert(newOrUpdatedSupplier, onApiFulfilled, onApiRejected);
    await supplierItemsStore.resetLoaded();
  } catch (error) {
    return setErrors({ apiError: error });
  }
};
</script>

<style scoped type="scss">
input[type=number] {
  text-align: right;
}

.required::after {
  content: " *";
  color: var(--bs-danger);
}
</style>
